import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { projectsData } from "../Home/data-projets";

import "./style.scss";

const Projet = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  let project = null;
  for (const category of projectsData) {
    project = category.projects.find((p) => p.id === id);
    if (project) break;
  }

  if (!project) {
    return <p>Projet introuvable.</p>;
  }

  return (
    <div className="project-detail-container">
      <aside className="project-info">
        <button
          className="back-button"
          onClick={() => {
            navigate("/");
            window.scrollTo(0, 0);
          }}
          aria-label="Retour à la page précédente"
        >
          ←
        </button>

        <h6 className="category btn-category">{project.category}</h6>
        <h3 className="title">{project.title}</h3>
        <p className="date">{project.date}</p>

        <h6 className="brief">{project.brief}</h6>

        <div className="softwares">
          {project.softwares.map((software, index) => (
            <h6 key={index} className="btn-software">
              {software}
            </h6>
          ))}
        </div>

        <div className="creative-process">
          {/*<h5>Démarche créative :</h5>*/}
          <p>{project.creativeProcess}</p>
        </div>

        {project.synopsis && (
          <div className="synopsis">
            <h5>Synopsis :</h5>
            <p>{project.synopsis}</p>
          </div>
        )}
      </aside>

      <section className="project-medias">
        {project.medias.map((media, index) => {
          if (media.type === "image" && media.src) {
            return (
              <div className="media-wrapper" key={index}>
                <img
                  src={media.src}
                  alt={media.alt || project.title}
                  className="project-image"
                  onLoad={(e) => {
                    const img = e.target;
                    const isVertical = img.naturalHeight > img.naturalWidth;
                    if (isVertical) {
                      img.parentElement.classList.add("vertical-wrapper");
                    }
                  }}
                />
              </div>
            );
          } else if (media.type === "vimeo" && media.src) {
            return (
              <div className="media-wrapper" key={index}>
                <iframe
                  src={media.src}
                  title={`Vidéo ${index + 1} - ${project.title}`}
                  frameBorder="0"
                  allow="autoplay; fullscreen"
                  allowFullScreen
                  className="project-video"
                ></iframe>
              </div>
            );
          }
          return null;
        })}
      </section>
    </div>
  );
};

export default Projet;
